import React, {Component} from 'react';

export default class ReviewersTable extends Component {
    render() {
        const {isReadonly, reviewers, data, onCheckboxChecked} = this.props;

        if (reviewers.length === 0) {
            return null;
        }

        return (
            <div className="form-group">
                <div className="table-responsive">
                    <table className="table table-bordered table-striped table-hover">
                        <thead>
                        <tr>
                            <th className="bg-warning text-primary">{window.__js_general.username}</th>
                            <th>{window.__js_bid_reviews.documents_review}</th>
                            <th>{window.__js_bid_reviews.technical_bid_review}</th>
                            <th>{window.__js_bid_reviews.financial_bid_review}</th>
                        </tr>
                        </thead>
                        <tbody>
                        {
                            reviewers.map((item) => {
                                let canAssessStage1 = false;
                                let canAssessStage2 = false;
                                let canAssessStage3 = false;

                                if (data.hasOwnProperty(item.value)) {
                                    const element = data[item.value];

                                    canAssessStage1 = (element.can_assess_stage1 === true);
                                    canAssessStage2 = (element.can_assess_stage2 === true);
                                    canAssessStage3 = (element.can_assess_stage3 === true);
                                }

                                return (
                                    <tr key={item.value}>
                                        <td style={{verticalAlign: 'middle'}}>{item.label}</td>
                                        <td style={{verticalAlign: 'middle'}}>
                                            <input type="checkbox"
                                                   value="1"
                                                   disabled={isReadonly}
                                                   checked={canAssessStage1}
                                                   onChange={(e) => onCheckboxChecked(item.value, 'can_assess_stage1', e.target.checked)}/>
                                        </td>
                                        <td style={{verticalAlign: 'middle'}}>
                                            <input type="checkbox"
                                                   value="1"
                                                   disabled={isReadonly}
                                                   checked={canAssessStage2}
                                                   onChange={(e) => onCheckboxChecked(item.value, 'can_assess_stage2', e.target.checked)}/>
                                        </td>
                                        <td style={{verticalAlign: 'middle'}}>
                                            <input type="checkbox"
                                                   value="1"
                                                   disabled={isReadonly}
                                                   checked={canAssessStage3}
                                                   onChange={(e) => onCheckboxChecked(item.value, 'can_assess_stage3', e.target.checked)}/>
                                        </td>
                                    </tr>
                                );
                            })
                        }
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
};